import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    textAlign: "center",
    padding: "20px 0",
  },
}));

const Location = ({ id }) => {
  const classes = useStyles();
  return (
    <div className="parallax" className={classes.container} id={id}>
      <Typography variant="h3" align="center">
        Our Location
      </Typography>
      <Typography ariant="subtitle1" align="center" style={{ padding: 15 }}>
        217 Martha Street <br />
        Euless, TX 76040 <br />
        <a href="tel:8176840702">817-684-0702</a>
      </Typography>
      <Typography
        ariant="subtitle1"
        align="center"
        style={{ paddingBottom: 10 }}
      >
        Monday - Friday <br />
        Lunch 11:00am - 2:30pm <br />
        Dinner 5:00pm - 9pm
      </Typography>
      <Typography
        ariant="subtitle1"
        align="center"
        style={{ paddingBottom: 10 }}
      >
        Saturaday <br />
        Monday - Friday 11:00a - 9:00pm
      </Typography>
      <Typography ariant="subtitle1" align="center" style={{ paddingBottom: 20 }}>
        Sunday Closed
      </Typography>
      <iframe
        width="450"
        height="250"
        frameborder="0"
        src="https://www.google.com/maps/embed/v1/place?key=AIzaSyDXPrbO5Ax-p-irAd_XF6pO3NDEdumFVA0&q=thai+noodle+euless"
        allowfullscreen
      ></iframe>
    </div>
  );
};

export default Location;
